export const handleActivationKey = (event, callback) => {
	if (event.key === 'Enter' || event.key === ' ') {
		event.preventDefault();
		callback(event);
	}
};

export const handleEscapeKey = (event, callback) => {
	if (event.key === 'Escape') {
		event.preventDefault();
		callback(event);
	}
};

export const announceToScreenReader = (message, priority = 'polite') => {
	const liveRegion = document.getElementById('sr-live-region');
	if (!liveRegion || !message) return;

	liveRegion.setAttribute('aria-live', priority);
	liveRegion.textContent = '';
	window.setTimeout(() => {
		liveRegion.textContent = message;
	}, 100);
};
